import React from 'react';
import { FileText, Download } from 'lucide-react';
import { technicalSpecsData } from '../mock';

export const TechnicalSpecs = () => {
  const handleDownload = (title) => {
    // Mock download functionality
    alert(`Downloading: ${title}\n\nNote: This is a demo. Actual PDF files will be available on production.`);
  };

  return (
    <section className="relative py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-block mb-4">
            <span className="text-sm tracking-[0.3em] uppercase text-gray-500 font-light">
              Technical Resources
            </span>
            <div className="h-px w-16 bg-gray-900 mt-2 mx-auto" />
          </div>
          <h2 className="text-4xl lg:text-5xl font-light text-gray-900 mb-6">
            Specifications & Documentation
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Comprehensive technical specifications for architects and engineers
          </p>
        </div>

        {/* Specs Grid */}
        <div className="grid md:grid-cols-2 gap-6 max-w-4xl mx-auto">
          {technicalSpecsData.map((spec) => (
            <div
              key={spec.id}
              className="group relative bg-white rounded-lg border border-gray-200 p-8 hover:border-gray-900 hover:shadow-xl transition-all duration-500 cursor-pointer"
              onClick={() => handleDownload(spec.title)}
            >
              {/* Icon */}
              <div className="mb-6">
                <div className="w-14 h-14 rounded-lg bg-gray-100 flex items-center justify-center transition-all duration-500 group-hover:bg-gray-900">
                  <FileText className="w-7 h-7 text-gray-700 group-hover:text-white transition-colors duration-500" />
                </div>
              </div>

              {/* Content */}
              <h3 className="text-xl font-medium text-gray-900 mb-3 leading-tight">
                {spec.title}
              </h3>
              <p className="text-gray-600 text-sm mb-6">
                {spec.description}
              </p>

              {/* Download Button */}
              <div className="flex items-center gap-2 text-gray-900 text-sm font-medium group-hover:gap-4 transition-all duration-300">
                <Download className="w-4 h-4" />
                <span>Download PDF</span>
              </div>

              {/* Blueprint corner decoration */}
              <div className="absolute top-4 right-4 w-8 h-8 border-r border-t border-gray-200 group-hover:border-gray-900 transition-colors duration-500" />
              <div className="absolute bottom-4 left-4 w-8 h-8 border-l border-b border-gray-200 group-hover:border-gray-900 transition-colors duration-500" />
            </div>
          ))}
        </div>

        {/* Additional Info */}
        <div className="mt-16 text-center">
          <p className="text-gray-600 text-sm">
            Need custom specifications or additional technical information?{' '}
            <button
              onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
              className="text-gray-900 font-medium underline underline-offset-2 hover:no-underline transition-all"
            >
              Contact our technical team
            </button>
          </p>
        </div>
      </div>
    </section>
  );
};